import CustomerAssignmentDetails from "./customer-assignment-details"
import CustomerAssignmentList from "./customer-assignment-list";

function CustomerAssignments({ customerId, subpage }) {
  if(subpage) {
    return <CustomerAssignmentDetails subpage={subpage} customerId={customerId} />;
  } else {
    return <CustomerAssignmentList customerId={customerId} />
  }
}

export default CustomerAssignments